module.exports = __webpack_public_path__ + "26d88a021b1fb42ff66c13d24ce4fe66.svg";